import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core'

import { ApiPreofferService } from '@data/services/modules/preoffer/api-preoffer.service'
import { PreofferStatus, PreofferSummary } from '@data/interfaces/preoffer.interface'
import { AuthService } from '@data/services/modules/auth/auth.service'

//* Los filtros de la bandeja: lo que espera a Legal y lo que ya decidió.
export const REVIEW_FILTERS: ReadonlyArray<{ value: PreofferStatus; label: string }> = [
  { value: 'legal_review', label: 'Por autorizar' },
  { value: 'issued', label: 'Autorizadas' },
  { value: 'returned', label: 'Regresadas' },
]

//* Lo que abrió la preoferta (plan v4.3 T-15): la CIEC del cliente, el barrido, sus obligados o una reevaluación.
export const TRIGGER_LABELS: Record<string, string> = {
  ciec_completed: 'CIEC completada',
  sweep: 'Foto asentada',
  guarantors_changed: 'Cambio de obligados',
  manual: 'Reevaluación manual',
}

/**
 * Bandeja «Preofertas por autorizar» (plan v4.3 §9.3 y §2b, D-57): una por cliente. Legal autoriza o regresa; Admin la ve en solo lectura
 * (`lease-preoffer.view-reviews`). Por omisión, lo que espera a Legal, del más viejo al más nuevo.
 */
@Component({
  selector: 'app-preoffer-reviews-list',
  templateUrl: './preoffer-reviews-list.component.html',
  styleUrls: ['./preoffer-reviews-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreofferReviewsListComponent implements OnInit {
  items: PreofferSummary[] = []
  status: PreofferStatus = 'legal_review'
  loading = false
  loadError: string | null = null

  readonly filters = REVIEW_FILTERS
  readonly triggers = TRIGGER_LABELS
  readonly canReview = inject(AuthService).hasModulePermission('lease-preoffer', 'review')

  private readonly api = inject(ApiPreofferService)
  private readonly cd = inject(ChangeDetectorRef)

  ngOnInit(): void {
    this.load()
  }

  setStatus(status: PreofferStatus): void {
    if (status === this.status) return
    this.status = status
    this.load()
  }

  load(): void {
    this.loading = true
    this.loadError = null
    this.api.reviews(this.status).subscribe((response) => {
      this.loading = false
      if (response.error) {
        this.items = []
        this.loadError = response.status === 403 ? 'No tienes permiso para ver la bandeja de preofertas.' : response.msg
      } else this.items = response.data ?? []
      this.cd.markForCheck()
    })
  }

  trackById(_index: number, item: PreofferSummary): string {
    return item._id
  }
}
